module.exports = __webpack_public_path__ + "img/icon-delivery-van.8bc272d4.svg";